/** 999 -> "999", 1700 -> "1.7k", 1_300_000 -> "1.3M". */
export function formatCount(n: number): string {
  if (n < 1000) return String(n);
  const units = [[1e9, 'B'], [1e6, 'M'], [1e3, 'k']] as const;
  for (const [div, suffix] of units) {
    if (n >= div) {
      const v = n / div;
      const s = v >= 10 ? Math.floor(v).toString() : (Math.floor(v * 10) / 10).toString();
      return `${s}${suffix}`;
    }
  }
  return String(n);
}

export function timeAgo(ts: number): string {
  const s = Math.max(0, (Date.now() - ts) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)}d ago`;
  return new Date(ts).toLocaleDateString();
}

export const instrumentLabel = (k: string) => k.replace(/_/g, ' ');
